import { render, staticRenderFns } from "./Attacks.vue?vue&type=template&id=4f77c70f&scoped=true&"
import script from "./Attacks.vue?vue&type=script&lang=js&"
export * from "./Attacks.vue?vue&type=script&lang=js&"
import style0 from "./Attacks.vue?vue&type=style&index=0&id=4f77c70f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f77c70f",
  null
  
)

export default component.exports